import { render, staticRenderFns } from "./TrainingRegisterDownloadModal.vue?vue&type=template&id=5659ef12"
import script from "./TrainingRegisterDownloadModal.vue?vue&type=script&lang=ts"
export * from "./TrainingRegisterDownloadModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports